<template>
    <div>
        <h3 class="mb-3">Assest Register</h3>
        <!-- checking permissions  -->
        <template v-if="hasPermission">
            <vx-card noShadow noRound>
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                        <vs-input
                            :value="asset_register.id ? `Asset #${asset_register.id}` : 'Auto Generated'"
                            label="Asset ID"
                            readonly
                            class="w-full"
                        />
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                        <SelectForeign
                            :model="asset_register.reported_by"
                            label="Reported By"
                            placeholder="Auto Filled"
                            :multiple="false"
                            :load_initial="false"
                            :label_keys="['first_name', 'last_name']"
                            :show_id_in_label="true"
                            :endpoint="`${$store.state.apiendpoints.organisation_users}?is_active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="false"
                            :disabled="true"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.reported_by">
                            {{ api_errors.reported_by.join(', ') }}
                        </small>
                    </vs-col>
                    
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                        <label class="vs-input--label block">Chainage</label>
                        <vs-row class="mt-1">
                            <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-0 pr-1">
                                <div class="flex" style="align-items: center">
                                    <label class="vs-input--label block mr-3">From</label>
                                    <vs-input
                                        v-model="asset_register.chainage_from"
                                        class="w-full"
                                        :disabled="mode != 'e'"
                                    />
                                </div>
                                <small class="block text-danger mt-1" v-if="api_errors.chainage_from">
                                    {{ api_errors.chainage_from.join(', ') }}
                                </small>
                            </vs-col>
                            <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-1 pr-0">
                                <div class="flex" style="align-items: center">
                                    <label class="vs-input--label block mr-3">To</label>
                                    <vs-input
                                        v-model="asset_register.chainage_to"
                                        class="w-full"
                                        :disabled="mode != 'e'"
                                    />
                                </div>
                                <small class="block text-danger mt-1" v-if="api_errors.chainage_to">
                                    {{ api_errors.chainage_to.join(', ') }}
                                </small>
                            </vs-col>
                        </vs-row>
                    </vs-col>
    
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                        <SelectForeign
                            :model.sync="asset_register.category"
                            label="Category"
                            placeholder="Type to Search.."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['name', ]"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.data_categories}?issue_type_category=asset_register&active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="false"
                            :disabled="mode != 'e'"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.category">
                            {{ api_errors.category.join(', ') }}
                        </small>
                    </vs-col>
                    
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                        <label class="vs-input--label block mb-1">Description</label>
                        <vs-textarea v-model="asset_register.observation" :disabled="mode != 'e'" />
                        <small class="block text-danger mt-1" v-if="api_errors.observation">
                            {{ api_errors.observation.join(', ') }}
                        </small>
                    </vs-col>
    
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                        <label class="vs-input--label block mb-1">Date Created</label>
                        <FormatText :text="asset_register.created_on" format="datetime" />
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="px-0">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                            <label class="vs-input--label block mb-1" v-if="mode == 'v'">Images</label>
                            <FileSelection
                                :images.sync="asset_register.images"
                                :read_only="mode != 'e'"
                            />
                            <small class="block text-danger mt-1" v-if="api_errors.images">
                                {{ api_errors.images.join(', ') }}
                            </small>
                        </vs-col>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="px-0">
                        <LocationChooser :disabled="mode != 'e'" :latitude.sync="asset_register.location_latitude" :longitude.sync="asset_register.location_longitude" :api_errors="{latitude: api_errors.location_latitude, longitude: api_errors.location_longitude}" />
                    </vs-col>
                </vs-row>
                <vs-row class="mt-base" v-if="mode == 'e'">
                    <vs-col class="text-center">
                        <vs-button @click="save" :disabled="submit_disabled">
                            Save
                        </vs-button>
                    </vs-col>
                </vs-row>
            </vx-card>
        </template>
        <template v-else>
            <PermissionDenied />
        </template>
    </div>
</template>

<script>

import FileSelection from "../Issue/Components/FileSelection.vue"
import LocationChooser from '../Issue/Components/LocationChooser.vue'

import { Request } from '../../utils/requests';

export default {
    props: {
        mode: {
            type: String,
            required: true
        }
    },
    components: {FileSelection, LocationChooser},
    data() {
        return {
            asset_register: {
                id: null,
                reported_by: this.$store.state.organisation.organisation_user,
                created_on: new Date().toISOString(),
                category: null,
                chainage_from: null,
                chainage_to: null,
                observation: null,
                location_latitude: null,
                location_longitude: null,
                images: []
            },

            submit_disabled: false,
            api_errors: {}
        }
    },
    watch: {
        "$route.params.asset_id"(newV, oldV) {
            if (newV == oldV)
                return;
            this.init();
        }
    },
    computed: {
        viewAsset() {
            return this.hasAccess('read', 'asset_register', ['all', 'own'])
        },
        createAsset() { 
            return this.hasAccess('create', 'asset_register', 'all') 
        },
        editAsset() { 
            return this.hasAccess('edit', 'asset_register', ['all', 'own'], [this.asset_register.reported_by.id]) 
        },
        hasPermission() {
            return (!this.asset_register.id && this.createAsset) || (this.asset_register.id && this.mode=='e' && this.editAsset) || (this.asset_register.id && this.mode=='v' && this.viewAsset)
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.asset_id = this.$route.params.asset_id
            if (this.asset_id) this.load_data()
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.data_asset_register + this.asset_id + "/"
            
            this.$vs.loading()
            
            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.asset_register = res
                },
                err => {
                    this.$vs.loading.close()
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {
            let request_method = 'POST', url = this.$store.state.apiendpoints.data_asset_register
            if (this.asset_id) {
                request_method = 'PUT'
                url += this.asset_id + '/'
            }

            let payload = {
                ...this.asset_register
            }

            if (this.asset_register.images.length == 0) {
                this.api_errors = {
                    "images": [
                        "Please select atleast 1 image",
                    ]
                }
                this.$vs.notify({
                    time: 3000,
                    title: 'Error',
                    text: "Please fix the errors and try again!",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
                return
            }

            this.submit_disabled = true

            Request(this, request_method, url, null, payload).then(
                async res => {
                    try {
                        
                        await this.upload_images(res.id)
                        this.asset_register = {...res, images: this.asset_register.images}

                        this.submit_disabled = false

                        this.$vs.notify({
                            time: 3000,
                            title: 'Saved',
                            text: "Saved Successfully!",
                            iconPack: 'feather',
                            icon: 'icon-check-circle',
                            color: 'success'
                        })
                        this.$router.push({name: 'asset-register-list'})
                    } catch (e) {
                        this.submit_disabled = false
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An erorr occurred while uploading images. Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                },
                err => {
                    this.submit_disabled = false
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An unknown error occurred! Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })

                    }
                }
            )
        },
        async upload_images(asset_id) {
            for (let i=0; i < this.asset_register.images.length; i++) {
                this.$set(this.asset_register.images[i], 'status', 'u')
                try {
                    let data = await this.upload_single_image(asset_id, this.asset_register.images[i])
                    this.$set(this.asset_register.images[i], 'status', 'c')
                    if (data != null)
                        this.$set(this.asset_register.images, i, data)
                } catch (e) {
                    this.$set(this.asset_register.images[i], 'status', 'f')
                    throw e
                }
            }
        },
        async upload_single_image(asset_id, image_obj) {

            return new Promise( (resolve, reject) => {
                if (typeof(image_obj) == 'string') resolve(null)
    
                let payload = new FormData()
                payload.append('image', image_obj.image)

                Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.data_asset_register_image, asset_id), null, payload).then(
                    res => resolve(res),
                    err => reject(err)
                )
               
            })
        },
    }
}
</script>